
<template>
  <sui-page>
    <sui-page-header title="sui-page-tab-box-type"/>
    <sui-page-contents>
      <sui-showcase-manual-box :raw-file="component">
        <sui-showcase-box title="Default usage" :raw-file="sourceB1" collapsible><sample-b1/></sui-showcase-box>
      </sui-showcase-manual-box>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import component from '!raw-loader!~common/components/form/SuiPageTabBoxType/SuiPageTabBoxType';

import sampleB1 from             "./sample/sampleB1";
import sourceB1 from '!raw-loader!./sample/sampleB1';

export default {
  name : "manual_pageTabBoxType",
  components : {
      sampleB1,
  },
  data() {return {
      component,
      sourceB1,
  }}
}
</script>